import { render, staticRenderFns } from "./OrganizationalUnitSelect.vue?vue&type=template&id=1727ef40&"
import script from "./OrganizationalUnitSelect.vue?vue&type=script&lang=js&"
export * from "./OrganizationalUnitSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports